import fallBallReportImage from '../../assets/images/social/fall-ball-report-gulf-coast.jpg';
import standoutSophomoreImage from '../../assets/images/social/standout-sophomore-2026-27.jpg';
import wereBackImage from '../../assets/images/social/were-back-next-chapter.jpg';
import risingStockJabethImage from '../../assets/images/social/rising-stock-keenan-jabeth.jpg';

// Content for the "Follow JUCO Pipeline" section on the homepage. Each entry is
// a real JUCO Pipeline post: `url` is the post's link and `image` its picture
// (import it like the images above).
//
// Optional image settings:
// - fit: 'contain' shows the whole image (for graphics with text) instead of
//   cropping it to fill the frame.
// - focus: which part of a cropped photo to keep in view, e.g. 'center 20%'.
// Leave `date` empty to hide it.
//
// FEATURED_POST_ID picks which post gets the large spot; the next four posts in
// the list fill the "Recent" column.
export const FEATURED_POST_ID = 'rising-stock-keenan-jabeth';

export const SOCIAL_POSTS = [
  {
    id: 'rising-stock-keenan-jabeth',
    category: 'Rising Stock',
    headline: "Rising Stock: FSW's Keenan Jabeth",
    description:
      'Florida SouthWestern State College: .380/.464/.652 in 2026 and a 2026 All-Conference Freshman Team pick.',
    date: '2026-10-30',
    platform: 'instagram',
    url: 'https://www.instagram.com/p/DfIX7t2IwNk/',
    image: risingStockJabethImage,
    fit: 'contain',
  },
  {
    id: 'were-back-next-chapter',
    category: 'Announcement',
    headline: "We're Back: The Next Chapter Starts Now",
    description: 'Back in business. The next chapter starts now.',
    date: '2026-10-29',
    platform: 'instagram',
    url: 'https://www.instagram.com/p/DfGIIDCsEfF/',
    image: wereBackImage,
    fit: 'contain',
  },
  {
    id: 'fall-ball-report-gulf-coast',
    category: 'Fall Ball Report',
    headline: 'Fall Ball Report: Gulf Coast State College',
    description:
      'Five Gulf Coast State sophomores to know: MD Johnson (LHP), Davis Avera (OF), Carter Ward (LHP), Lucas Badalato (OF/1B), and Brayden Mann (C).',
    date: '',
    platform: 'instagram',
    url: 'https://www.instagram.com/p/DfDgIJEy_n2/',
    image: fallBallReportImage,
    fit: 'contain',
  },
  {
    id: 'standout-sophomore-2026-27',
    category: 'Standout Sophomore',
    headline: 'Standout Sophomore 2026-2027',
    description: '',
    date: '2026-09-08',
    platform: 'x',
    url: 'https://x.com/JucoPipeline/status/2097463050747949404',
    image: standoutSophomoreImage,
    focus: 'center 25%',
  },
];
